'use client'
import Image from 'next/image'
import { BaseEmptyStateProps } from '../types'
import { CMSButton } from '@/ui/components/CMSButton'

interface BaseEmptyStateComponentProps extends BaseEmptyStateProps {
  title: string
  description: string
  imageSrc: string
  variant?: 'base' | 'subtle'
  className?: string
}

export const BaseEmptyState: React.FC<BaseEmptyStateComponentProps> = ({
  button,
  hasButton,
  title,
  description,
  imageSrc,
  variant = 'base',
  className,
}) => {
  return (
    <div className={`bg-bg-${variant} border border-[#DCE9F9] rounded-md p-card-s ${className}`}>
      <div className="flex flex-col md:flex-row gap-6 items-center">
        <div className="relative w-full h-[200px]">
          <Image
            src={imageSrc}
            alt={title}
            fill
            style={{ aspectRatio: '16/10' }}
            className="object-contain"
          />
        </div>

        <div className="flex flex-col gap-6">
          <p className="text-title-M-medium text-text-base">{title}</p>
          <p className="text-body-S-regular text-text-base">{description}</p>
          {hasButton && button && (
            <div className="flex">
              <CMSButton {...button} appearance="primary" size="md" />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
